(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    (function() {
    // Customize your placeholder phrases here
    const phrases = [
      "Search for summer dresses...",
      "Search for running shoes...",
      "Search for hoodies...",
      "What are you looking for?"
    ];

    let phraseIndex = 0;
    let characterIndex = 0;
    let isDeleting = false;
    let typingSpeed = 100;
    let timeoutId = null;
    let searchInput = null;

    function typeEffect() {
      if (!searchInput) return;
      
      const currentPhrase = phrases[phraseIndex];
      
      if (isDeleting) {
        searchInput.setAttribute('placeholder', currentPhrase.substring(0, characterIndex - 1));
        characterIndex--;
        typingSpeed = 40; 
      } else {
        searchInput.setAttribute('placeholder', currentPhrase.substring(0, characterIndex + 1));
        characterIndex++;
        typingSpeed = 100; 
      }

      if (!isDeleting && characterIndex === currentPhrase.length) {
        isDeleting = true;
        typingSpeed = 2000; 
      } else if (isDeleting && characterIndex === 0) {
        isDeleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length; 
        typingSpeed = 500; 
      }

      timeoutId = setTimeout(typeEffect, typingSpeed);
    }

    function initAnimation() {
      // Clear any existing loop to prevent duplicates
      if (timeoutId) clearTimeout(timeoutId);
      
      searchInput = document.getElementById('animated-search-input');
      
      if (searchInput) {
        typeEffect();
      }
    }

    // 1. Try to run immediately if DOM is already parsed
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnimation);
    } else {
      initAnimation();
    }

    // 2. Fallback for Shopify Theme Editor changes & AJAX section reloads
    document.addEventListener('shopify:section:load', initAnimation);
    window.addEventListener('load', initAnimation);
  })();
  } catch(e) { console.error(e); }
})();

})();
